import "@Styles/Controls/Print/printRecipeDrawer_sm.less";
export default {
  data: function data() {
    return {
      config: {},
      isExpanded: false
    };
  },
  methods: {
    init: function init(config) {
      this.config = config || {};
      this.$_removeHideSection();
      this.$_setClassAndLabel();
    },
    toggleIsExpanded: function toggleIsExpanded() {
      this.isExpanded = !this.isExpanded;
      this.$_setClassAndLabel();
    },
    $_removeHideSection: function $_removeHideSection() {
      var parent = this.$_getParentElement();
      parent.classList.remove('hideSection');
    },
    $_setClassAndLabel: function $_setClassAndLabel() {
      var parent = this.$_getParentElement();
      var toggleLabel = this.$refs.toggleLabel;

      if (this.isExpanded) {
        parent.classList.remove('hideFromPrint');
        if (toggleLabel) toggleLabel.textContent = this.config.hideDrawerText;
      } else {
        parent.classList.add('hideFromPrint');
        if (toggleLabel) toggleLabel.textContent = this.config.showDrawerText;
      }
    },
    $_getParentElement: function $_getParentElement() {
      /* istanbul ignore next */
      return this.$el.parentElement;
    }
  }
};